import { render, staticRenderFns } from "./PoStudyStoryRegist.vue?vue&type=template&id=83c5fcfe&scoped=true"
import script from "./PoStudyStoryRegist.vue?vue&type=script&lang=js"
export * from "./PoStudyStoryRegist.vue?vue&type=script&lang=js"
import style0 from "./PoStudyStoryRegist.vue?vue&type=style&index=0&id=83c5fcfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c5fcfe",
  null
  
)

export default component.exports